import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getOnlineShopGoodsList } from '@/api/bairun/bianlidian'; //  此处请自行替换地址

import infoList from '@/mixins/infoList';

var _this;

export default {
  name: 'OnlineShopGoodsComponent',
  filters: {
    getActivityTypes: function getActivityTypes(activityTypes) {
      var activityTypesArr = activityTypes.split(',');
      var arr = [];

      if (activityTypesArr.includes('1')) {
        arr.push('券');
      }

      if (activityTypesArr.includes('2')) {
        arr.push('积分');
      }

      return arr.length === 0 ? '' : '返' + arr.join('+');
    }
  },
  mixins: [infoList],
  props: ['goodsComponentFormData'],
  data: function data() {
    return {
      listApi: getOnlineShopGoodsList,
      type: '',
      isInit: false,
      searchText: '',
      multipleSelection: [],
      multipleSelectionAll: [],
      idKey: 'goodsDetailNo',
      dialogVisible: true
    };
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var that;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // 使用keepalive的页面,重新展示都会调用
              that = _this2;

              if (!that.isInit) {
                console.log('OnlineShopGoodsComponent activated');
                that.isInit = true;

                _this.init();
              }

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var that;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              that = _this3;

              if (!that.isInit) {
                console.log('OnlineShopGoodsComponent created');
                that.isInit = true;

                _this3.init();
              }

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    init: function init() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log('OnlineShopGoodsComponent init');
                console.log(_this4.goodsComponentFormData.selection);

                if (_this4.goodsComponentFormData.selection) {
                  _this4.multipleSelectionAll = JSON.parse(JSON.stringify(_this4.goodsComponentFormData.selection));
                }

                _this.onSearch();

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    getTableDataPublic: function getTableDataPublic() {
      var that = this;
      this.getTableData(this.page, this.pageSize, function () {
        that.$nextTick(function () {
          that.setSelectRow();
        });
      });
    },
    // 条件搜索前端看此方法
    onSearch: function onSearch() {
      this.page = 1;
      this.pageSize = 5;
      this.searchInfo = {};
      this.searchInfo.sellerId = this.goodsComponentFormData.sellerId;
      this.searchInfo.showStatus = 1;

      if (!this.searchInfo.sellerId || this.searchInfo.sellerId === null || undefined === this.searchInfo.sellerId || this.searchInfo.sellerId == 0 || this.searchInfo.sellerId < 0 || this.searchInfo.sellerId == '') {
        return;
      }

      if (this.searchText === '') {
        this.getTableDataPublic();
        return;
      }

      if (isNaN(this.searchText)) {
        this.searchInfo.goodsDetailTitle = this.searchText;
      } else {
        this.searchInfo.spuNo = this.searchText;
      }

      this.getTableDataPublic();
    },
    // 输入事件
    inputChange: function inputChange() {
      this.$forceUpdate();
    },
    handleSelChange: function handleSelChange(val) {
      this.multipleSelection = val;
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.saveSelection();
      this.page = val;
      this.getTableDataPublic();
    },
    goodsSelDialogClose: function goodsSelDialogClose() {
      if (this.$parent.goodsSelDialogClose) {
        this.$parent.goodsSelDialogClose();
      }
    },
    goodsSelDialogOk: function goodsSelDialogOk(res) {
      this.saveSelection();
      console.log(this.multipleSelection);
      console.log(this.multipleSelectionAll);

      if (this.$parent.goodsSelDialogOk) {
        this.$parent.goodsSelDialogOk(this.multipleSelectionAll);
      }
    },
    // 设置选中的方法
    setSelectRow: function setSelectRow() {
      if (!this.multipleSelectionAll || this.multipleSelectionAll.length <= 0) {
        return;
      } // 标识当前行的唯一键的名称


      var idKey = this.idKey;
      var selectAllIds = []; // eslint-disable-next-line no-unused-vars

      var that = this;
      this.multipleSelectionAll.forEach(function (row) {
        selectAllIds.push(row[idKey]);
      });
      this.$refs.table.clearSelection();

      for (var i = 0; i < this.tableData.length; i++) {
        if (selectAllIds.indexOf(this.tableData[i][idKey]) >= 0) {
          this.$refs.table.toggleRowSelection(this.tableData[i], true);
        }
      }

      this.$forceUpdate();
    },
    // 记忆选择核心方法
    saveSelection: function saveSelection() {
      // 标识当前行的唯一键的名称
      var idKey = this.idKey;
      var that = this; // 如果总记忆中还没有选择的数据，那么就直接取当前页选中的数据，不需要后面一系列计算

      if (this.multipleSelectionAll.length <= 0) {
        this.multipleSelectionAll = this.multipleSelection;
        return;
      } // 总选择里面的key集合


      var selectAllIds = [];
      this.multipleSelectionAll.forEach(function (row) {
        selectAllIds.push(row[idKey]);
      });
      var selectIds = []; // 获取当前页选中的id

      this.multipleSelection.forEach(function (row) {
        selectIds.push(row[idKey]); // 如果总选择里面不包含当前页选中的数据，那么就加入到总选择集合里

        if (selectAllIds.indexOf(row[idKey]) < 0) {
          that.multipleSelectionAll.push(row);
        }
      });
      var noSelectIds = []; // 得到当前页没有选中的id

      this.tableData.forEach(function (row) {
        if (selectIds.indexOf(row[idKey]) < 0) {
          noSelectIds.push(row[idKey]);
        }
      });
      noSelectIds.forEach(function (id) {
        if (selectAllIds.indexOf(id) >= 0) {
          for (var i = 0; i < that.multipleSelectionAll.length; i++) {
            if (that.multipleSelectionAll[i][idKey] == id) {
              // 如果总选择中有未被选中的，那么就删除这条
              that.multipleSelectionAll.splice(i, 1);
              break;
            }
          }
        }
      });
    }
  }
};